(function($i){
    /** @namespace $i.contextPath */
    // Default values for the options.
    var defaults = {
             // Whether cookies have been consented to. If not the user will be prompted to accept the cookie policy.
            cookieConsent: false,

            // Whether the user can cancel at any point.
            closeable: true,

            // Whether to automatically load the modal via ajax.
            autoLoad: false,

            back: window.location.href
    }, params = {
        language: 'en',
        country: 'US',
        cookies: true,
        back: window.location.href
    }, modal, options;

    function deleteParam(url, key) {
        var parts = url.split('?');
        if (parts.length < 2) {
            return url;
        }
        var params = parts[1]
            .split('&')
            .filter(function (param) {
                return param.indexOf(key + '=') !== 0;
            })
            .join('&');
        return parts[0] + (params.length > 0 ? '?' + params : '');
    }

    $i.languageModal = function(opts) {
        var overlay = $('<div class="dialog-overlay"></div>').appendTo('body');
        options = $.extend({}, defaults, opts);
        params.back = opts.back || params.back;

        params.cookies = options.cookieConsent;

        // As this process uses several dialogs we create our own overlay to prevent a flash between dialogs.
        $(window).on('resize', function () { overlay.css({height: $(document).height(), width: $(window).width() }); }).trigger('resize');

        function applyDir(dir) {
            if (dir === 'rtl') {
                $('link[href*="' + $i.contextPath + '/styles/style.css"]').each(function() {
                    var newHref = $(this).attr('href');
                    newHref = newHref.replace('style.css', 'style-rtl.css');
                    $(this).attr('href', newHref);
                });
                $('html').attr('dir', 'rtl');
           } else {
               $('link[href*="' + $i.contextPath + '/styles/style-rtl.css"]').each(function() {
                   var newHref = $(this).attr('href');
                   newHref = newHref.replace('style-rtl.css', 'style.css');
                   $(this).attr('href', newHref);
               });
               $('html').attr('dir', 'ltr');
           }
        }

        function complete() {
            params.back = deleteParam(params.back, 'locale');
            window.location.href = $i.contextPath + "/user/updateCookies?" + $.param(params);
        }

        var originalDir = $('html').attr('dir');

        function cancelled() {
            applyDir(originalDir);
            overlay.remove();
            $('html').css('overflow', '');
        }

        function cookieModal() {
            $(document).scrollTop(0);
            if (params.cookies) {
                complete();
            }
            else {
                $i.dialog({
                    closeable: false,
                    modal: false,
                    titleKey: 'cookie.title',
                    url: $i.contextPath + '/user/cookie?language=' + params.language + ' .modal-body',
                    width: '80%',
                    load: function() {
                        // Replace the title and the button text with the text from the AJAX request (will be in correct language when
                        // language has changed).
                        this.$el.find('.dialog-head h2').text(this.$el.find('.cookie-policy-dialog-title-text').text());
                        this.$el.find('.dialog-foot button').text(this.$el.find('.cookie-policy-dialog-button-text').text());
                    },
                    buttonKeys: { 'button.agree': { classes: 'btn-primary', callback: function() {
                        params.cookies = true;
                        complete();
                    }}}
                });
            }
        }

        function countryModal() {
            $(document).scrollTop(0);
            $i.dialog({
                closeable: options.closeable,
                modal: false,
                titleKey: 'country.select',
                url: $i.contextPath + '/i18n/country?language=' + params.language + ' .modal-body',
                width: '80%',
                buttonKeys: null,
                load: function() {
                    var dialog = this;
                    // Get specified language direction and swap out css for appropriate styling.
                    var dir = $('#county-select-master').data("content");
                    applyDir(dir);
                    // we don't need the dialog box footer
                    dialog.box.find('.dialog-foot').remove();
                    dialog.box.find(".country-link").on('click', function(){
                        params.country = $(this).attr('data-country');
                        dialog.destroy();
                    });
                    // User may have changed their language. Update the dialog title.
                    this.$el.find('.dialog-head h2').text(this.$el.find('.country-dialog-title-text').text());
                    countryDialogOnLoad(dialog);

                    // Clicking on the nav tabs changes the dialog content and therefore the content may be larger, so we need to trigger resize.
                    dialog.box.on('click', '.nav-tabs', function() { setTimeout( function() {dialog.resize(); },600) });
                },
                close: function(closedByUser) {
                    this.destroy();
                    if (closedByUser) {
                        cancelled();
                    } else {
                        cookieModal();
                    }
                }
            });
        }

        // Enable the type ahead functionality of the country search box.
        function countryDialogOnLoad(dialog) {
            var countrySearchInput = $('.country-search-input');
            var countrySelect = $('#country-selector');

            var countrySuggestionEngine = new Bloodhound({
                name: 'countries',
                local: function() {
                    // Converts options from select#country-selector to an array of objects that have the 'countryName',
                    // the 'alternativeSpellings', the 'relevancyBooser' for sorting, and the 'countryCode'.
                    return countrySelect.find('option').map(function() {
                        var option = $(this), optionValue = option.text();
                        return $i.isEmpty(optionValue) ? null : {
                            countryCode: option.attr('value'),
                            countryName: option.text(),
                            alternativeSpellings: option.attr('data-alternative-spellings'),
                            relevancyBooster: option.attr('data-relevancy-booster')
                        };
                    }).get();
                },
                sorter: function(left, right) {
                    // -1: left is bigger, 0: equal, 1: right is bigger
                    var leftName = left.countryName.toLocaleLowerCase(),
                        rightName = right.countryName.toLocaleLowerCase(),
                        inputValue = countrySearchInput.val().toLocaleLowerCase();
                    if (left.countryName === right.countryName) {
                        return 0;
                    }
                    else if ((leftName.indexOf(inputValue) === 0) !== (rightName.indexOf(inputValue) === 0)) {
                        // If the country name started with the typed value it should come first.
                        return leftName.indexOf(inputValue) === 0 ? -1 : 1;
                    }
                    else if (leftName.indexOf(inputValue) !== rightName.indexOf(inputValue)) {
                        // If the country name contains the input anywhere it should come first.
                        return leftName.indexOf(inputValue) > -1 ? -1 : 1;
                    }
                    else if (left.relevancyBooster !== right.relevancyBooster) {
                        // Countries with higher relevancy should come first.
                        return right.relevancyBooster - left.relevancyBooster;
                    }
                    else {
                        // Fallback to basic string comparison.
                        return leftName < rightName ? -1 : 1;
                    }
                },
                datumTokenizer: function(d) {
                    return _.union(Bloodhound.tokenizers.whitespace(d.countryName), Bloodhound.tokenizers.whitespace(d.alternativeSpellings));
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 4
            });

            countrySuggestionEngine.initialize();

            countrySearchInput.typeahead({
                minLength: 1,
                highlight: true
            }, {
                name: 'countries',
                source: countrySuggestionEngine.ttAdapter(),
                displayKey: 'countryName'
            }).on('typeahead:selected', function(event, suggestion) {
                params.country = suggestion.countryCode;
                dialog.destroy();
            });
        }

        var scroller;

        $i.dialog({
            closeable: options.closeable,
            modal: false,
            titleKey: 'i18n.language.select.en',
            url: $i.contextPath + '/i18n/language .modal-body',
            width: '60%',
            buttonKeys: null, // No buttons.
            load: function() {
                // Set dir to ltr by default and fade in dialog and overlay only after dialog is ready.
                this.box.hide();
                $('html').css('overflow', 'hidden');
                applyDir('ltr');
                overlay.css({ "background-color": "#000000", "opacity": "0.7", "filter": "alpha(opacity=70)" }).fadeIn("fast");
                this.box.fadeIn("fast");

                var dialog = this, title = dialog.box.find('h2'),
                    i = 1,
                    titles = [];
                // we don't need the dialog box footer
                dialog.box.find('.dialog-foot').remove();
                dialog.box.find('.language').on('click', function(){
                    params.language = $(this).attr('lang');
                    dialog.destroy();
                }).each(function(){
                    titles.push($(this).attr('data-title'));
                });

                function scroll() {
                    // increment counter for next time
                    i++;

                    // reset to beginning if at end of language list
                    if(i >= titles.length) {
                        i = 0;
                    }

                    // fade out last language and fade in next in the list
                    $(title).fadeOut(200, function(){
                        $(title).text(titles[i]).fadeIn(200);
                    });
                }

                scroller = window.setInterval(scroll, 2000);
            },
            close: function(closedByUser) {
                if (scroller) {
                    window.clearInterval(scroller);
                }
                if (closedByUser) {
                    cancelled();
                } else {
                    countryModal();
                }
            }
        });

    };

})(isis);
